<template>
  <div>
    <template v-if="column.dicOption === '2'">
      <el-select
        v-model="value"
        filterable
        remote
        reserve-keyword
        :placeholder="placeholder"
        :remote-method="remoteMethod"
        :loading="loading"
        :disabled="disabled"
        @change="handleChange">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </template>
    <el-select v-else
    v-model="value"
    :disabled="disabled"
    :placeholder="placeholder"
    @change="handleChange">
      <el-option
        v-for="item in dicData"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import mixinSelectRemote from './mixins/selectRemote'
export default {
  inject: ['viewFormData'],
  props: ['column', 'scope'],
  mixins: [mixinSelectRemote],
  data() {
    const {
      dicData
    } = this.column
    return {
      dicData,
      value: this.scope.row[this.column.prop]
    }
  },
  watch: {
    scope({ row }) {
      this.value = row[this.column.prop]
    }
  },
  methods: {
    handleChange(v) {
      this.$emit('on-edit', v, this.column.prop, this.scope.$index)
    }
  }
}
</script>
